
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminViewComponent } from './modules/admin-view/admin-view.component';
import { SendSmsComponent } from './modules/common/components/send-sms/send-sms.component';
import { DoctorsViewComponent } from './modules/doctors-view/doctors-view.component';
import { ContactoAdministrativoComponent } from './modules/employee-view/actuaciones/create-actuationes/contacto-administrativo/contacto-administrativo.component';
import { InformMedicoComponent } from './modules/employee-view/actuaciones/create-actuationes/inform-medico/inform-medico.component';
import { InspectionComponent } from './modules/employee-view/actuaciones/create-actuationes/inspection/inspection.component';
import { OrdernComponent } from './modules/employee-view/actuaciones/create-actuationes/ordern/ordern.component';
import { CreateDischargeComponent } from './modules/employee-view/baja/create-discharge/create-discharge.component';
import { CreateLeaveComponent } from './modules/employee-view/bajas/create-leave/create-leave.component';
import { EmployeeViewComponent } from './modules/employee-view/employee-view.component';
import { CreateNewEmployeeComponent } from './modules/employee/components/create-new-employee/create-new-employee.component';
import { TemplatesComponent } from './modules/maintenance/templates/templates.component';
import { SelectionGenericComponent } from './modules/selection-generic/selection-generic.component';
import { StaffCountViewComponent } from './modules/staff-count/staff-count-view/staff-count-view.component';
import { StaffImportViewComponent } from './modules/staff-count/staff-import-view/staff-import-view.component';
import { AuthGuard } from './_guards/auth.guard';

import { AttributeImportComponent } from './modules/attribute-import/attribute-import.component';
import { DebugViewComponent } from './modules/debug-view/debug-view.component';
import { PermitsComponent } from './modules/users/permits/permits.component';
import { UsersComponent } from './modules/users/users.component';

import { TemporaryComponent } from './modules/common/pages/temporary/temporary.component';
import { CompanyViewComponent } from './modules/company-view/company-view.component';
import { ConveniosComponent } from './modules/convenios/convenios.component';
import { CoordinatorComponent as MainCoordinatorsView } from './modules/coordinator/coordinator.component';
//import { CoordinatorsComponent } from './modules/coordinators/coordinators.component';
import { DeletedLeavesComponent } from './modules/deleted-leaves/deleted-leaves.component';
import { LaborViewComponent } from './modules/labor-view/labor-view.component';
import { LeaveImportComponent } from './modules/leave-import/leave-import.component';
import { CitacionTemplatesComponent } from './modules/maintenance/citacion-templates/citacion-templates.component';
import { RoleGuard } from './_guards/role.guard';
import { CoordinadoreMainComponent } from './modules/coordinadore-main/coordinadore.main.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { GruposEmpresaComponent } from './modules/grupos-empresa/grupos-empresa.component';

const routes: Routes = [
    {path :"",loadChildren:()=>import('../app/modules/authentication/authentication.module')
    .then(mod=>mod.AuthenticationModule)
    },
    {path :"selection-view",loadChildren:()=>import('../app/modules/selection-generic/selection-generic.module')
    .then(mod=>mod.SelectionGenericModule)
    },
    {path :"task-selection",loadChildren:()=>import('../app/modules/task-selection-view/task-selection-view.module')
    .then(mod=>mod.TaskSelectionViewModule)
    },
    {path :"doctor-maganement",loadChildren:()=>import('../app/modules/doctor/doctor.module')
    .then(mod=>mod.DoctorModule)
    },
    {path :"agenda",loadChildren:()=>import('../app/modules/agenda-view/agenda-view.module')
    .then(mod=>mod.AgendaViewModule)
    },
    {path :"administratives",loadChildren:()=>import('../app/modules/administratives/administratives.module')
    .then(mod=>mod.AdministrativesModule)
    },
    {path :"staff-count",loadChildren:()=>import('../app/modules/staff-count/staff-count.module')
    .then(mod=>mod.StaffCountModule)
    },
    {path :"reports-view",loadChildren:()=>import('../app/modules/reports/reports.module')
    .then(mod=>mod.ReportsModule)
    },
    {path :"debug-view",loadChildren:()=>import('../app/modules/debug-view/debug-view.module')
    .then(mod=>mod.DebugViewModule)
    },
    {path :"monthly-doctor-expenses-view",loadChildren:()=>import('../app/modules/doctor-billing/doctor-billing.module')
    .then(mod=>mod.DoctorBillingModule)
    },
    {path :"employee",loadChildren:()=>import('../app/modules/employee-view/employee-view.module')
    .then(mod=>mod.EmployeeViewModule)
    },
    {path :"due",loadChildren:()=>import('../app/modules/due/due.module')
    .then(mod=>mod.DueModule)
    },
    {
        path: 'coordinators-main',
        component: MainCoordinatorsView,
        canActivate: [AuthGuard],
    },
    {
        path: 'admin',
        component: AdminViewComponent,
        canActivate: [AuthGuard],
    },
   
    {
        path: 'temp',
        component: TemporaryComponent,
    },
    {
        path: 'doctor',
        component: DoctorsViewComponent,
        canActivate: [AuthGuard],     
    },
    // {
    //     path: 'agenda',
    //     component: AgendaViewComponent,
    //     canActivate: [AuthGuard],
    // },
    {
        path: 'plantillas_lopd',
        component: TemplatesComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['4']}
    },
    {
        path: 'plantillas_citacion',
        component: CitacionTemplatesComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['4']}
    },
    {
        path: 'employee',
        component: EmployeeViewComponent,
        canActivate: [AuthGuard],
    },
    // {
    //     path: 'create-actuation/visit/:id/:operation',
    //     component: VisitComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'create-actuation/visita-ausente/:id/:operation',
    //     component: VisitaAusenteComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'create-actuation/contacto-fallido/:id/:operation',
    //     component: ContactoFallidoComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'create-actuation/contacto/:id/:operation',
    //     component: ContactoComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'task-selection',
    //     component: TaskSelectionViewComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'gestion-con-mutua/:id/:operation',
    //     component: GestionConMutuaComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'Contacto-administrativo/:id/:operation',
    //     component: ContactoAdministrativoComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'Contacto-Administrativo-No-Contesta/:id/:operation',
    //     component: ContactoAdminNoContestaComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'solicitud/:id/:operation',
    //     component: SolicitudOperationComponent,
    //     canActivate: [AuthGuard],
    // },
    {
        path: 'informe-medico/:id/:operation',
        component: InformMedicoComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['605']}
    },
    {
        path: 'documento-medico/:id/:operation',
        component: InformMedicoComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['601']}
    },
    {
        path: 'documento-sms/:id/:operation',
        component: InformMedicoComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['601']}
    },
    // {
    //     path: 'comentario/:id/:operation',
    //     component: ComentariosComponent,
    //     canActivate: [AuthGuard],
    // },

    // {
    //     path: 'ordern/:id/:operation',
    //     component: OrdernComponent,
    //     canActivate: [AuthGuard],
    // },
    {
        path: 'send-sms',
        component: SendSmsComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['1003']}
    },
    
    // {
    //     path: 'selection-view',
    //     component: SelectionGenericComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'reports-view',
    //     component: ReportsComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'monthly-doctor-expenses-view',
    //     component: DoctorMonthlyExpensesComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'doctor-bill-view',
    //     component: BillViewComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'create-leave/:empId/:operation',
    //     component: CreateLeaveComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'create-discharge/:leaveId/:operation',
    //     component: CreateDischargeComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'create-inspection/:leaveId/:operation/:actionId',
    //     component: InspectionComponent,
    //     canActivate: [AuthGuard],
    // },
    {
        path: 'create-new-employee',
        component: CreateNewEmployeeComponent,
        canActivate: [AuthGuard],
    },
    // {
    //     path: 'doctor-maganement',
    //     component: ManagementViewComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'staff-count',
    //     component: StaffCountViewComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'staff-import',
    //     component: StaffImportViewComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'debug-view',
    //     component: DebugViewComponent,
    //     canActivate: [AuthGuard],
    // },

    {
        path: 'leave-import',
        component: LeaveImportComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['832']}
    },

    {
        path: 'users',
        component: UsersComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['809']}
    },
    {
        path: 'users-permits',
        component: PermitsComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['809']}
    },
    {
        path: 'attribute-import',
        component: AttributeImportComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['832']}
    },
    {
        path: 'company-view',
        component: CompanyViewComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['1']}
    },
    // {
    //     path: 'ordern/:id/:operation',
    //     component: OrdernComponent,
    //     canActivate: [AuthGuard],
    // },
    {
        path: 'send-sms',
        component: SendSmsComponent,
        canActivate: [AuthGuard],
    },
   
    // {
    //     path: 'selection-view',
    //     component: SelectionGenericComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'reports-view',
    //     component: ReportsComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'monthly-expenses-view',
    //     component: MonthlyExpensesComponent,
    //     canActivate: [AuthGuard],
    // },

    // {
    //     path: 'doctor-bill-view',
    //     component: BillViewComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'activate-account',
    //     component: ActivateUserComponent,
    // },
    // {
    //     path: 'create-leave/:empId/:operation',
    //     component: CreateLeaveComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'create-discharge/:leaveId/:operation',
    //     component: CreateDischargeComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'create-inspection/:leaveId/:operation/:actionId',
    //     component: InspectionComponent,
    //     canActivate: [AuthGuard],
    // },
    {
        path: 'create-new-employee',
        component: CreateNewEmployeeComponent,
        canActivate: [AuthGuard],
    },
    // {
    //     path: 'doctor-maganement',
    //     component: ManagementViewComponent,
    //     canActivate: [AuthGuard],
    // },
    {
        path: 'staff-count',
        component: StaffCountViewComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['856']}
    },
    {
        path: 'staff-import',
        component: StaffImportViewComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['856']}
    },
        {
        path: 'coordinadore-main',
        component: CoordinadoreMainComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: ['819', '801'] }
    },
/*     {
        path: 'coordinators',
        component: CoordinatorsComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['819','801']}
    }, */
    // {
    //     path: 'coordinators-main',
    //     component: MainCoordinatorsView,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'pedir-cita/:id',
    //     component: PedirCitaComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'citacion/:id',
    //     component: CitacionComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: 'aknowledgement/:id/:tipo',
    //     component: AknowledgementComponent,
    //     canActivate: [AuthGuard],
    // },
    {
        path: 'convenios',
        component: ConveniosComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['45']}
    },
    // {
    //     path: 'doctor-empresa',
    //     component: DoctorEmpresaComponent,
    //     canActivate: [AuthGuard],
    // },
    {
        path: 'labor-calendar',
        component: LaborViewComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['895']}
    },
    {
        path: 'delete-leaves',
        component: DeletedLeavesComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['841']}
    },
    // {
    //     path: 'administratives',
    //     component: AdministrativesComponent,
    //     canActivate: [AuthGuard],
    // },
    {
        path: 'cartera-empresas',
        component: GruposEmpresaComponent,
        canActivate: [AuthGuard,RoleGuard],
        data: {roles: ['809']}
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule], providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}]
})

export class AppRoutingModule {}
export const routing = RouterModule.forRoot(routes, { useHash: true });
